import { EMOTION_COLORS, SENTIMENT_COLORS } from '../components/social-media/design-tokens'

// ThemeAI shows sentiment and emotion in the same colours as the social
// dashboards, so "Positive" or "Joy" reads the same everywhere (Adam, 23 Sep:
// "previously sentiment and emotion coding was colour based"). Undefined for
// a label with no colour, and the caller falls back to its neutral style.
const lookup = (palette: Record<string, string>) => (label?: string) =>
  label ? palette[label.trim().toLowerCase()] : undefined

export const sentimentColour = lookup(SENTIMENT_COLORS)
export const emotionColour = lookup(EMOTION_COLORS)
